import(/* webpackMode: "eager", webpackExports: ["ComponentPageEvent"] */ "/app/src/features/shared/data-layer-component/data-layer-component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Error404"] */ "/app/src/features/shared/error-404/error-404.tsx");
